module.exports = __webpack_public_path__ + "static/media/icon_plus_yellow.3f34fc97.svg";